import React from 'react';
const Footer: React.FC = () => {
  return <footer className="w-full bg-secondary text-white py-12" data-id="element-81">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl text-center" data-id="element-82">
        <h2 className="text-2xl font-serif font-bold mb-2" data-id="element-83">Belén Gimeno.</h2>
        <p className="mb-6" data-id="element-84">
          Coach en adicción al azúcar y bienestar femenino.
        </p>
        <p className="italic" data-id="element-85">(Tras 12 años luchando… y ganando).</p>
      </div>
    </footer>;
};
export default Footer;